import { useState } from 'react';
import { CompetitionStatusClient, CompetitionStatusDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCompetitionStatusApi = () => {
    const apiClient = new CompetitionStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CompetitionStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCompetitionStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CompetitionStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CompetitionStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCompetitionStatus(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CompetitionStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCompetitionStatusById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CompetitionStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCompetitionStatuses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CompetitionStatuses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCompetitionStatus(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CompetitionStatus');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};